import React from 'react';
import {useCustomer} from '../../hooks/api/metadata';
import {getSavesQuota} from '../../shared/customer';
import {Flex, Text, FlexProps, Box, Tooltip} from '@chakra-ui/react';

const CreditProgressBar = (props: FlexProps) => {
  const customer = useCustomer();
  const {current, limit} = getSavesQuota(customer);
  const usedPercentage = limit ? (current / limit) * 100 : 100;

  return (
    <Flex
      position="relative"
      h="8px"
      display={{base: 'none', md: 'flex'}}
      borderRadius="full"
      overflow="hidden"
      bg="kgray.200"
      {...props}
    >
      {/* Filled portion - represents available credits */}
      <Box
        position="absolute"
        w={`${usedPercentage}%`}
        h="100%"
        bg="kgreen.400"
        transition="width 0.3s ease-in-out"
      />
    </Flex>
  );
};

export const CreditDisplay = () => {
  const customer = useCustomer();
  const {current, limit} = getSavesQuota(customer);
  if (!limit) {
    return null;
  }

  return (
    <Flex direction="column" gap="3">
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontWeight="medium">Credit Usage</Text>
        <Flex alignItems="center" gap="2">
          <Text fontWeight="medium">{current.toLocaleString()}</Text>
          <Text fontWeight="medium">/ {limit.toLocaleString()}</Text>
        </Flex>
      </Flex>

      <CreditProgressBar width="100%" display="flex" />
    </Flex>
  );
};

// Simple credit usage display for the header
export const CreditUsage = ({...props}: FlexProps) => {
  const customer = useCustomer();
  const {limit, current, remaining} = getSavesQuota(customer);
  if (!limit) {
    return null;
  }

  return (
    <Tooltip
      label={`${current.toLocaleString()} / ${limit.toLocaleString()} credits used`}
      placement="bottom"
      hasArrow
      shouldWrapChildren={true}
    >
      <Flex alignItems="center" gap="2" whiteSpace="nowrap" {...props}>
        <CreditProgressBar width="50px" />

        <Text fontSize="sm" display={{base: 'none', md: 'block'}}>
          {remaining.toLocaleString()} credits
        </Text>
      </Flex>
    </Tooltip>
  );
};
